module.exports = __webpack_public_path__ + "img/changjing-04.d411e9cf.png";